/**
 * Novelune 品牌 - Welfare 页面配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

const primaryGradient = brandTheme.primaryGradient || 'linear-gradient(90deg, #FFBC7A 0%, #FF6B3D 100%)'

export const theme = {
  btnBg: brandTheme.primaryColor,
  btnText: brandTheme.textInverse,
  coinsColor: brandTheme.primaryColor,
  coinsGradient: primaryGradient,
  actionGradient: brandTheme.primaryGradient,
  checkinBtnGradient: primaryGradient,
} as const

export const resources = {
  homeBg: '/images/novelune/home-bg.webp',
  welfareGold: '/images/novelune/welfare-gold.png',
  welfareBox: '/images/novelune/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
